import { render, staticRenderFns } from "./suForecastReport.vue?vue&type=template&id=21e47698"
import script from "./suForecastReport.vue?vue&type=script&lang=js"
export * from "./suForecastReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports